import React, { useContext, useState, useEffect } from "react";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Switch, Route, Redirect, useRouteMatch, useLocation } from "react-router-dom";
import Dashboard from "../Dashboard";
import { apiGet } from "app/Services/ApiService";
import { Utils } from "common/Utils";
import { contractorApiUrls } from "common/ApiUrls";
import { PortalNames } from "common/Portals";

import Contracts from 'area/contractor/Contracts';
import Uploads from "area/contractor/Uploads";

import Layout from "./Layout"

export default function ContractorRoutes({ portal }) {
    const { modalIsOpen,setModalIsOpen, companyId,setInsuredId, setCompany,userInfo } = useContext(PrivateRoutesContext);
    let { path } = useRouteMatch();

    useEffect(() => {
        let selectedCompany = localStorage.getItem(`selectedCompanyId`);
        console.log(`selected company ${selectedCompany}`)
        if (selectedCompany !== undefined){
          if (selectedCompany != null && selectedCompany != "") {
            setCompany(selectedCompany)
          }
          else{
            console.log("Prompting for company from ERUIRoutes")
            setModalIsOpen(true)
          }  
        }
        else{
          console.log("selectedCompany undefined Prompting for company from ContractorRoutes")
          setModalIsOpen(true)
        }
    
        document.title = "AXIM FringeSecure | Contractor";
      }, []);

    return (
        <Layout>
            <Switch>
            <Route exact path={`${path}/`}>
                <Redirect to={`${path}/dashboard`} />
            </Route>
            <Route exact path={`${path}/dashboard`} component={Dashboard} />
            <Route exact path={`${path}/contracts`} component={Contracts} />
            <Route exact path={`${path}/uploads`} component={Uploads} />
            </Switch>
        </Layout>
    )
}